import React from 'react';
import {Stack, Typography} from "@mui/material"
import EmailVerificationAlert from "./EmailVerificationAlert"
import {Outlet} from "react-router-dom"
import {useApi} from "../../hooks/useApi"
import OrgSidebar from "./Nav/OrgSidebar"
import RightSidebar from "./RightSidebar"
import ContentArea from "./ContentArea"
import ActivitiesList from "../activities/ActivitiesList"

function FullwidthContainer() {
    const {currentUser} = useApi()

    return (
        <>
            <OrgSidebar/>
            <ContentArea>
                {currentUser && currentUser.emailVerified == null &&
                    <EmailVerificationAlert/>
                }
                <Outlet/>
            </ContentArea>
            <RightSidebar>
                <Stack spacing={3}>
                    <Typography variant="subtitle1">Latest Activity</Typography>
                    <ActivitiesList/>
                </Stack>
            </RightSidebar>
        </>
    );
}

export default FullwidthContainer;
